import { WorkOrderType } from '@xbcb/work-order-types';
import { SupportedCountryAbbreviation } from '@xbcb/shared-types';

export const workOrderTypeToCountryCodeMap = {
  [WorkOrderType.DeliveryOrder]: SupportedCountryAbbreviation.US,
  [WorkOrderType.GbCustomsEntry]: SupportedCountryAbbreviation.GB,
  [WorkOrderType.NlCustomsEntry]: SupportedCountryAbbreviation.NL,
  [WorkOrderType.FrCustomsEntry]: SupportedCountryAbbreviation.FR,
  [WorkOrderType.DeCustomsEntry]: SupportedCountryAbbreviation.DE,
};

export const getCountryCodeFromWorkOrderType = (
  workOrderType: WorkOrderType,
) => {
  return (
    workOrderTypeToCountryCodeMap[
      workOrderType as keyof typeof workOrderTypeToCountryCodeMap
    ] ||
    SupportedCountryAbbreviation[
      workOrderType
        .substr(0, 2)
        .toUpperCase() as keyof typeof SupportedCountryAbbreviation
    ]
  );
};
